export default __webpack_public_path__ + "static/media/word.0d27b926.png";